import {getLastNotificationsCheckTimestamp, setLastNotificationsCheckTimestamp} from "./NotificationUtils";

export const logout = () => {
  let timestamp = getLastNotificationsCheckTimestamp();
  localStorage.clear();
  setLastNotificationsCheckTimestamp(timestamp);
  window.location.href = '/'
};